<template>
    <CardPage :section="15" :page="4" :backOverrideFunction="backClick" :nextDisabled="nextDisabled">
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="!selectedRelationship">
                <p v-if="numRelationshipsAnswered < 1">
                    First, select the type of relationship you want to explore:
                </p>
                <p v-else-if="numRelationshipsAnswered < MIN_ANSWERED">
                    Now, select another type of relationship:
                </p>
                <p v-else>Select another type of relationship, or click <span class="font-italic">Next</span> to continue:</p>
                <v-btn
                    v-for="(key, index) in relationshipsOrder"
                    :key="index"
                    block
                    round
                    color="primary"
                    @click="select(relationships[key])"
                    class="relationship"
                    :class="{ answered: !!relationships[key].answer }"
                >
                    {{ relationships[key].text }}
                    <div class="check" v-if="!!relationships[key].answer">
                        <v-avatar :size="24" class="success white--text">
                            <v-icon small dark>check</v-icon>
                        </v-avatar>
                    </div>
                </v-btn>
            </div>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition hide-on-leave>
            <div v-if="selectedRelationship">
                <p class="headline text-xs-center">{{ relationships[selectedRelationship].text }}</p>
                <p>When it comes to bottoming with this type of partner, what is the <span class="font-weight-bold">farthest</span> you are willing to go?</p>
                <p class="mb-0">When I bottom with this type of partner:</p>
                <div
                    v-for="(choice, index) in choices"
                    :key="index"
                    class="grey pa-3 mb-1"
                    :class="{
                        success: relationships[selectedRelationship].answer === choice,
                        'lighten-3': relationships[selectedRelationship].answer !== choice
                    }"
                    @click.stop="answer(choice)"
                    v-ripple
                >
                    {{ choice }}
                </div>
                <v-textarea outline label="Something else" :rows="1" auto-grow @input="update"></v-textarea>
            </div>
        </v-slide-x-reverse-transition>
        <template v-if="selectedRelationship" v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn v-if="relationships[selectedRelationship].other" @click="done" round large color="primary">Done</v-btn>
            <v-spacer></v-spacer>
        </template>
    </CardPage>
</template>

<script>
import router from '@/router';
import { get } from 'vuex-pathify';

const MIN_ANSWERED = 2;

export default {
    data() {
        return {
            MIN_ANSWERED: MIN_ANSWERED,
            selectedRelationship: null
        };
    },
    computed: {
        relationships: get('section15/relationships'),
        relationshipsOrder: get('section15/relationshipsOrder'),
        choices: get('section15/choices'),
        numRelationshipsAnswered: get('section15/numRelationshipsAnswered')
    },
    methods: {
        backClick() {
            if (this.selectedRelationship) {
                this.selectedRelationship = null;
            } else {
                router.back();
            }
        },
        select(relationship) {
            this.selectedRelationship = relationship.id;
        },
        answer(choice) {
            this.$store.set(`section15/relationships@${this.selectedRelationship}.answer`, choice);
            this.$store.set(`section15/relationships@${this.selectedRelationship}.other`, '');
            this.selectedRelationship = null;
        },
        update(text) {
            this.$store.set(`section15/relationships@${this.selectedRelationship}.answer`, 'Something else');
            this.$store.set(`section15/relationships@${this.selectedRelationship}.other`, text);
        },
        done() {
            this.selectedRelationship = null;
        },
        nextDisabled() {
            return this.numRelationshipsAnswered < MIN_ANSWERED || this.selectedRelationship;
        }
    }
};
</script>

<style scoped>
.relationship {
    position: relative;
}
.check {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0%, -50%);
}
.answered {
    opacity: 0.5;
}
</style>
